import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Crown } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const TopCustomers = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/invoices/reports/top-customers`)
      .then((res) => setData(res.data))
      .catch(() => {});
  }, []);

  if (!data || data.customers.length === 0) return null;
  const fmt = (v) => `$${Number(v).toFixed(2)}`;

  return (
    <Card className="mb-6" data-testid="top-customers-board">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <Crown size={18} className="text-amber-500" />
          Top Customers — {data.year}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-2">
          {data.customers.map((c, i) => (
            <div key={c.customer_name} className="flex items-center gap-3 border-b last:border-b-0 py-2" data-testid={`top-customer-${i + 1}`}>
              <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${i === 0 ? 'bg-amber-400 text-white' : 'bg-gray-100 text-gray-600'}`}>{i + 1}</span>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm text-gray-900 truncate">{c.customer_name}</p>
                <p className="text-xs text-gray-500">{c.invoices} invoice{c.invoices !== 1 ? 's' : ''} · Collected {fmt(c.collected)}{c.outstanding > 0 ? ` · Owes ${fmt(c.outstanding)}` : ''}</p>
              </div>
              <p className="font-bold text-sm text-[#5c1a1a] shrink-0">{fmt(c.invoiced)}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
